import { render, staticRenderFns } from "./MessageOutgoingText.vue?vue&type=template&id=c6ef64a8&"
import script from "./MessageOutgoingText.vue?vue&type=script&lang=js&"
export * from "./MessageOutgoingText.vue?vue&type=script&lang=js&"
import style0 from "./MessageOutgoingText.vue?vue&type=style&index=0&id=c6ef64a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
